import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import localeDefault from "./locales/default/translation.json";
// import en_a2ziotcom from './locales/en_a2ziot.com/translation.json';
import ooredooLocale from "./locales/en_ooredoo/translation.json";

i18n.use(initReactI18next).init({
  debug: false,
  lng: "default",
  fallbackLng: "default", // use en if detected lng is not available

  // keySeparator: false, // we do not use keys in form messages.welcome

  interpolation: {
    escapeValue: false, // react already safes from xss
  },

  resources: {
    default: { translations: localeDefault },
    en_ooredoo: { translations: ooredooLocale },
    en_geolocstar: { translations: ooredooLocale },
    // en_petro: { translations: en_petro }
  },
  // have a common namespace used around the full app
  ns: ["translations"],
  defaultNS: "translations",
  saveMissing: true,
  returnEmptyString: false,
  parseMissingKeyHandler: (key) => {
    return `${key}`;
  },
});

export default i18n;
